export default "__VITE_ASSET__36_P21Q0__"